import express from 'express';
import { parsePayload } from '~/app/middleware';
import { diffModels } from '~/app/middleware/ContentModels';

const diffRouter = express.Router();

diffRouter.post('{/:id}', parsePayload, diffModels);

export default diffRouter;
